export enum ICargoTypeTabs {
  addNewCargoType = "1",
  cargoTypeTable = "2",
}
